// pdf.js's wasm for the offline viewer (visiodocs-app#655): a page opened from file:// cannot fetch, so the modules
// are inlined into the file as data URLs and handed to pdf.js through its `WasmFactory` option.

// The bytes of a base64 data URL, as webpack's asset/inline makes them
export function dataUrlBytes(dataUrl: string): Uint8Array {
    const binary = atob(dataUrl.slice(dataUrl.indexOf(',') + 1));
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}

// A pdf.js WasmFactory that answers from the bytes it was given, by file name, instead of fetching `wasmUrl`
export class InlineWasmFactory {
    constructor(private readonly files: Record<string, Uint8Array>) {}

    async fetch({ filename }: { filename: string }): Promise<Uint8Array> {
        const bytes = this.files[filename];
        if (!bytes) {
            throw new Error(`No inlined wasm file ${filename}`);
        }
        return bytes;
    }
}
